<payee-popup [onCancel]="cancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ "PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.TITLE" | translate }}</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>
    <p>{{ "PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.DESCRIPTION" | translate }}</p>
  </ng-template>

  <form
    class="upload-debug-mokk-form flex column"
    [formGroup]="form"
  >
    <payee-form-field width="max">
      <span payee-label>{{ "PAYEE_CASE_MOKK_TABLE.FILTERS.PAYEE_CASE_REFERENCE_ID" | translate }}</span>
      <input
        payee-input
        formControlName="payee_case_reference_id"
      />
      @if (form.get("payee_case_reference_id")?.invalid && form.get("payee_case_reference_id")?.dirty) {
        <span payee-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
      }
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>{{ "PAYEE_CASE_MOKK_TABLE.FILTERS.MOKK_LABEL" | translate }}</span>
      <payee-autocomplete
        formControlName="type"
        [options]="mokkTypeOptions"
        [displayWith]="mokkTypeDisplayWith"
        [requireSelection]="true"
        [clearable]="true"
      ></payee-autocomplete>
      @if (form.get("type")?.invalid && form.get("type")?.dirty) {
        <span payee-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
      }
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>{{ "PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.PARENT_MOKK_ID" | translate }}</span>
      <payee-autocomplete
        formControlName="parent_mokk_id"
        [options]="parentMokkOptions"
        [displayWith]="parentMokkDisplayWith"
        [requireSelection]="false"
        [clearable]="true"
      ></payee-autocomplete>
    </payee-form-field>

    <div class="file-upload-section flex column">
      <payee-dropzone
        title="{{ 'PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.FILE_TITLE' | translate }}"
        accept="application/pdf,.pdf"
        [multiple]="false"
        [isDisabled]="loading"
        (dropped)="filesDropped($event)"
      ></payee-dropzone>

      @if (file) {
        <div class="selected-file flex vcenter">
          <span class="file-name">{{ file.name }}</span>
          <button
            payee-mini-icon-button
            color="white"
            type="button"
            [disabled]="loading"
            (click)="removeFile()"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </div>
      }
    </div>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      {{ "PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.SUBMIT" | translate }}
    </button>
  </ng-template>
</payee-popup>
